"use client"

import { depictMerchant } from "@/lib/depict-client/depict-merchant"
import { useDepictClientSessionId } from "@/lib/depict-client/helpers/useDepictClientSessionId"
import { getDepictMarketCode } from "@/src/utils/depict/getDepictMarketCode"
import { useAppForCurrentLocale } from "@/src/utils/locale/useAppForCurrentLocale"
import { memo, useEffect } from "react"

const DepictPerformanceClient = () => {
    const countryCode = useAppForCurrentLocale().countryCode
    const depictSessionId = useDepictClientSessionId()
    useEffect(() => {
        if (!window.WeakRef) {
            window.WeakRef = class WeakRef<T extends object> {
                private weakMap: WeakMap<WeakRef<T>, T>

                constructor(target: T) {
                    this.weakMap = new WeakMap()
                    this.weakMap.set(this, target)
                }

                deref(): T | undefined {
                    return this.weakMap.get(this)
                }

                // Adding the [Symbol.toStringTag] property to satisfy TypeScript's WeakRef interface
                get [Symbol.toStringTag](): string {
                    return "WeakRef"
                }
            } as any
        }
        if (!countryCode) {
            return
        }

        import("@depict-ai/dpc").then(({ DPC }) => {
            new DPC(depictMerchant || "poc", {
                market: getDepictMarketCode(countryCode)
            }).setSessionId(depictSessionId)
        })
    }, [countryCode, depictSessionId])

    return null
}

export default memo(DepictPerformanceClient)
